<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-07-30 10:35:06
 * @LastEditors: hexy
 * @LastEditTime: 2024-08-30 14:03:42
 * @Description: 合同——明细客户弹窗界面
 * @FilePath: \PCMS（链接9091）\src\views\ShareSystem\components\report\accountTable.vue
-->
<template>
  <div>
    <el-dialog :visible.sync="dialog" width="1000px" :close-on-click-modal="false" @open="initData">
      <span slot="title" class="dialog-title">核算主体</span>
      <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">编码</span>
              <el-input v-model="tableParams.code"  style="width:150px;" placeholder="请输入"></el-input>
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">项目名称</span>
              <el-input v-model="tableParams.name"  style="width:150px;" placeholder="请输入"></el-input>
            </span>
            <el-button style="margin-left: 24px" icon="el-icon-search" size="medium" class="bottom_all"
              @click="getProject_HX()">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
          </div>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%"
          :data="accountTableData" tooltip-effect="dark" highlight-current-row @current-change="handleCurrentChange"  @row-dblclick="rowDblclick">
          <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
          <template v-for="(item, index) in accountTable">
            <el-table-column v-if="item" :key="index" :prop="item.prop" :label="item.label" :width="item.width"
              align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="item.label == '序号'"> {{ scope.$index + 1 }} </span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ total }}条</div>
            <el-pagination :current-page.sync="tableParams.page" :page-size="tableParams.pageSize"
              :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
              @size-change="sizeChange" @current-change="getProject_HX()"></el-pagination>
          </div>
          <div>
            <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
              @click="getProject_HX">刷新</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="reset">取 消</el-button>
        <el-button class="bottom_all" @click="submitDept">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { cardLogin_HX, getProject_HX } from "@/views/ShareSystem/api/mainHx.js";
export default {
  components: {
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    centerRow: {}
  },
  data() {
    return {
      tableParams: {
        page: 1,
        pageSize: 10,
        code: "",
        name: "",
        status: 1,//只查询启用状态
      },
      accessToken: "",
      total: 0,
      accountTableData: [],
      accountTable: [
        { label: "序号", width: "auto", prop: "index", status: true },
        { label: "编码", width: "auto", prop: "code", status: true },
        { label: "项目", width: "auto", prop: "name", status: true },
      ],
      currentRow: {},
      form: {},
      ncNo: "",
      userName: "",
    }
  },
  watch: {

  },
  methods: {
    init(){
      this.tableParams = this.$options.data().tableParams
    },
    async initData() {
      let that = this
      let res = await cardLogin_HX({ idCard: "icps" })
      if (res.code == 1001) {
        let info = res.data;
        if (info && info.accessToken) {
          that.accessToken = info.accessToken
          this.getProject_HX();
        }
      }
    },
    setNcNo(data) {
      this.ncNo = data.code
      this.userName = data.name
    },
    restParams() {
      this.tableParams = {
        page: 1,
        pageSize: 10,
        code: "",
        name: "",
      }
      this.initData();
    },
    getProject_HX() {
      if (!this.accessToken) {
        this.$message.error('accessToken获取为空～')
        return;
      } else {
        getProject_HX(this.tableParams, this.accessToken).then((res) => {
          this.accountTableData = res.data?.data;
          this.total = res.data.totalRows
        });
      }
    },
    submitDept() {
      if (this.currentRow.length == 0) {
        this.$message.warning("请选中一条数据");
        return;
      }
      this.$emit("setProject", this.currentRow)
      this.reset()
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    rowDblclick(row){
        this.currentRow = row;
        this.submitDept()
      },
    reset() {
      this.$emit("resetProject");
    },
    sizeChange(value) {
      this.tableParams.pageSize = value;
      this.initData();
    },
  }
}
</script>
<style lang="scss" scoped>
.addClass {
  display: flex;
  justify-content: end;
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

::v-deep .el-table__body tr.current-row>td {
  color: #fff;
  background: #00b85c !important;
}</style>